import { GasAllocationsPage } from "./GasAllocationsPage";

const GasAllocations = () => {
	return <GasAllocationsPage />;
};

export default GasAllocations;
